import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}banner`; // Fake API URL

export const getBanners = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const getBannerById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const createBanner = (banner) => {
    const token = localStorage.getItem('token');
    return axios.post(API_URL_WEB, banner, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const updateBanner = (id, banner) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/${id}`, banner, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const deleteBanner = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(API_URL_WEB + `/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const updateActive = (id, bannerProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/active-banner/${id}`,
        bannerProduct, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getBannerPaginate = (page = 1, limit = 10) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/banner/paginate?page=${page}&limit=${limit}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
        },
    });
};